import * as React from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import { Link } from 'react-router-dom'
import Menu from './Menu';
import CampanaNotificaciones from './Landing/Notificaciones/CampanaNotificaciones';
import AppVersion from './AppVersion/AppVersion';
import SearchBar from './SearchBar';


class NavBar extends React.Component {

    handleSearchInputKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.handleBuscar(e.target.value);
        }
    }

    handleBuscar = (valor) => {
        // Aquí va la lógica de búsqueda, por ahora solo mostramos el valor
        //console.log('Buscar:', valor);
    }


    state = {
        isSidebarVisible: false,
    };

    sideBarTogglerClickedSmall = () => {
        $("body").trigger("resize");
        $("body").addClass("mini-sidebar");
        $('.navbar-brand span').hide();
    }

    navTogglerClickedSmall = () => {
        const { isSidebarVisible } = this.state;
        $("body").toggleClass("show-sidebar");
        this.setState({ isSidebarVisible: !isSidebarVisible }, () => {
            const iconClass = this.state.isSidebarVisible ? "ti-close" : "ti-menu";
            $(".nav-toggler i").removeClass("ti-menu ti-close").addClass(iconClass);
        });
    };

    sideBarTogglerClickedLarge = () => {
        let page = $("body").hasClass("mini-sidebar");
        if (page) {
            $("body").removeClass("mini-sidebar");
            $('.logo-mega').attr('src', '/img/logo-marketplace-megatone.png');
            $('.sidebartoggler i').removeClass('ti-menu').addClass('ti-close');
        } else {
            $("body").addClass("mini-sidebar");
            $('.logo-mega').attr('src', '/img/mini-logo-marketplace-megatone.png');
            $('.sidebartoggler i').removeClass('ti-close').addClass('ti-menu');
        };
    };


    render() {
        const { impersonation } = this.props;
        const isImpersonating = !!impersonation?.isActive;

        return (

            <header className="topbar background-rojo-megatone" >
                <nav className="navbar top-navbar navbar-expand-sm navbar-light" >

                    <div className="navbar-header mt-10 background-gris-megatone">
                        <Link className="navbar-brand" to="/">
                            <img
                                className="logo-mega animated fadeInLeft"
                                alt="logo"
                                src="/img/logo-marketplace-megatone.png"
                            />
                        </Link>
                    </div>

                    <div className="navbar-collapse justify-content-between row" >

                        <div className="col-1 d-flex align-items-center" style={{ zIndex: 10, position: 'relative' }}>
                            <ul className="navbar-nav mr-auto d-lg-none">
                                <li className="nav-item">
                                    <a
                                        onClick={this.navTogglerClickedSmall}
                                        className="nav-link nav-toggler hidden-md-up waves-effect waves-dark"
                                    >
                                        <i className="sl-icon-menu" />
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        onClick={this.sideBarTogglerClickedSmall}
                                        className="nav-link sidebartoggler hidden-sm-down waves-effect waves-dark"
                                    >
                                        <i className="sl-icon-menu ti-menu" />
                                    </a>
                                </li>
                            </ul>

                            <ul className="navbar-nav mr-auto d-none d-lg-block">
                                <li className="nav-item">
                                    <a className="nav-link nav-toggler hidden-md-up waves-effect waves-dark" >
                                        <i className="sl-icon-close" />
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        onClick={this.sideBarTogglerClickedLarge}
                                        className="nav-link sidebartoggler hidden-sm-down waves-effect waves-dark"
                                    >
                                        <i className="sl-icon-close ti-close" />
                                    </a>
                                </li>
                            </ul>

                            {/* Pasar idSeller y listenClear prop a SearchBar */}
                            <div className="d-flex flex-column justify-content-center pt-2">
                                <SearchBar idSeller={this.props.idSeller} listenClear={true} />
                                <div className="ms-3 text-white mt-1" style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>
                                    <AppVersion />
                                </div>
                            </div>
                        </div>

                        <div className='col-11'>
                            <div className="w-100 row justify-content-end">


                                <div className="col-auto d-flex align-items-center">
                                    <CampanaNotificaciones />
                                </div>


                                <div className="col-auto navbar-nav my-lg-0">
                                    <Menu history={this.props.history} />
                                </div>

                            </div>
                        </div>

                    </div>
                </nav>

                {isImpersonating && (
                    <div
                        className="px-3 py-2 text-white"
                        style={{ backgroundColor: 'rgba(71, 8, 26, 0.92)', borderTop: '1px solid rgba(255,255,255,0.16)' }}
                    >
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 small">
                            <span>
                                Estas viendo la plataforma como <strong>{impersonation?.impersonatedNombre || this.props.userName}</strong> (ID {impersonation?.impersonatedUserId ?? this.props.userId}).
                            </span>
                            <span className="opacity-75">
                                Iniciada por {impersonation?.impersonatorNombre || 'administrador'}
                            </span>
                        </div>
                    </div>
                )}
            </header>
        );
    }
}

const mapStateToProps = (state) => ({
    idSeller: state.general?.idSeller,
    userId: state.general?.userId,
    userName: state.general?.userName,
    impersonation: state.general?.impersonation,
});

export default connect(mapStateToProps)(NavBar);
